export const ROLES = {
  admin: { label: "Super Administrator", color: "bg-navy-900 text-white" },
  director: { label: "Director", color: "bg-indigo-600 text-white" },
  bdm: { label: "Business Development Manager", color: "bg-brand text-white" },
  trainer: { label: "Clinical Trainer", color: "bg-emerald-600 text-white" },
  finance: { label: "Finance Manager", color: "bg-amber-600 text-white" },
};

export function fmtCurrency(n, currency = "NZD") {
  const v = Number(n || 0);
  return new Intl.NumberFormat("en-NZ", {
    style: "currency", currency, maximumFractionDigits: 0,
  }).format(v);
}

export function fmtNumber(n) {
  return new Intl.NumberFormat("en-NZ").format(Number(n || 0));
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-NZ", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return "—"; }
}

const STATUS_STYLES = {
  Active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Inactive: "bg-slate-100 text-slate-600 border-slate-200",
  Prospect: "bg-blue-50 text-blue-700 border-blue-200",
  Lost: "bg-red-50 text-red-700 border-red-200",
  Won: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Submitted: "bg-blue-50 text-blue-700 border-blue-200",
  "Manager Approved": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Finance Approved": "bg-violet-50 text-violet-700 border-violet-200",
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  High: "bg-red-50 text-red-700 border-red-200",
  Medium: "bg-amber-50 text-amber-700 border-amber-200",
  Low: "bg-slate-100 text-slate-600 border-slate-200",
  "To Do": "bg-slate-100 text-slate-600 border-slate-200",
  "In Progress": "bg-blue-50 text-blue-700 border-blue-200",
  Done: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export function statusClass(status) {
  return STATUS_STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200";
}

export function exportCSV(rows, filename) {
  if (!rows || !rows.length) return;
  const keys = Object.keys(rows[0]).filter((k) => !["_id"].includes(k));
  const header = keys.join(",");
  const body = rows
    .map((r) => keys.map((k) => {
      const val = r[k] == null ? "" : String(r[k]).replace(/"/g, '""');
      return `"${val}"`;
    }).join(","))
    .join("\n");
  const blob = new Blob([header + "\n" + body], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
